import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { Link } from "react-router-dom";
import helpersNumbers from "../../../../../helpers/numbers";
import validateFormsGiftUserRegister from "../../../../../validtions/forms/gift-user-register/add";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersTime from "../../../../../helpers/time";
import moment from "moment";

export default function Add() {
  const [amount, setAmount] = useState(1000000);
  const [message, setMessage] = useState();
  const history = useHistory();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestAddGiftRegisterUser = async (giftRegisterUser) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/gift-user-register/manage",
        giftRegisterUser,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return false;
    }

    return true;
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card ");
    element.scrollIntoView();
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDateForm();
    const resultValidate = validateFormsGiftUserRegister(dataForm);
    if (resultValidate != true) {
      setMessage({
        type_class: "alert alert-danger ",
        text: resultValidate,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddGiftRegisterUser =
      await sendRequestAddGiftRegisterUser(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddGiftRegisterUser) {
      return;
    }
    history.push("/finance/manage/gift-register-user/all");
  };

  const getDateForm = () => {
    return {
      amount: amount + "",
      start_date: getStartDate() + ":00",
      end_date: getEndDate() + ":00",
      description: document.querySelector("#description").value,
    };
  };

  const getStartDate = () => {
    return `${helpersTime.convertJalaliToGregorian(
      document.querySelector("#start-date input").value
    )} ${document.querySelector("#hour-start-date").value}:${
      document.querySelector("#minute-start-date").value
    }`;
  };

  const getEndDate = () => {
    return `${helpersTime.convertJalaliToGregorian(
      document.querySelector("#end-date input").value
    )} ${document.querySelector("#hour-end-date").value}:${
      document.querySelector("#minute-end-date").value
    }`;
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">
                  اضافه کردن هدایای ثبت نام کاربران
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/manage/gift-register-user/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      ساعت تاریخ شروع و پایان ۲۴ ساعته است.
                    </p>
                  </li>
                </ul>
              </div>
              <form onSubmit={sendForm}>
                <div>
                  <div className="pb-2">
                    <label>مبلغ هدیه</label>
                  </div>
                  <div>
                    <div className="input-group">
                      <input
                        type="text"
                        id="amount"
                        className="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amount)
                        )}
                        onChange={inputAmountChangeHandler}
                        onBeforeInput={inputAmountBeforeInputHandler}
                        dir="ltr"
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">تومان</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="py-2">
                  <div>
                    <label>تاریخ شروع</label>
                  </div>
                  <div className="d-flex align-items-center">
                    <div id="start-date" className="custom-data-picker ">
                      <DatePicker
                        placeholder="انتخاب تاریخ"
                        format="jYYYY/jMM/jDD"
                        preSelected={helpersTime.convertGregorianToJalali(
                          moment(helpersTime.getDateNow())
                            .add(1, "days")
                            .format("YYYY/M/D")
                        )}
                      />
                    </div>
                    <div className="text-nowrap pr-2">ساعت :</div>
                    <div className="px-2">
                      <input
                        className="form-control"
                        type="number"
                        id="hour-start-date"
                        onWheel={(event) => event.currentTarget.blur()}
                        min="0"
                        max="23"
                        required
                      />
                    </div>
                    <div className="text-nowrap">دقیقه :</div>
                    <div className="pr-2">
                      <input
                        className="form-control"
                        type="number"
                        onWheel={(event) => event.currentTarget.blur()}
                        id="minute-start-date"
                        min="0"
                        max="59"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="py-2">
                  <div>
                    <label>تاریخ پایان</label>
                  </div>
                  <div className="d-flex align-items-center">
                    <div id="end-date" className="custom-data-picker ">
                      <DatePicker
                        placeholder="انتخاب تاریخ"
                        format="jYYYY/jMM/jDD"
                        preSelected={helpersTime.convertGregorianToJalali(
                          moment(helpersTime.getDateNow())
                            .add(2, "days")
                            .format("YYYY/M/D")
                        )}
                      />
                    </div>
                    <div className="text-nowrap pr-2">ساعت :</div>
                    <div className="px-2">
                      <input
                        className="form-control"
                        type="number"
                        id="hour-end-date"
                        onWheel={(event) => event.currentTarget.blur()}
                        min="0"
                        max="23"
                        required
                      />
                    </div>
                    <div className="text-nowrap">دقیقه :</div>
                    <div className="pr-2">
                      <input
                        className="form-control"
                        type="number"
                        id="minute-end-date"
                        onWheel={(event) => event.currentTarget.blur()}
                        min="0"
                        max="59"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="pb-2">
                  <div>
                    <label>توضیحات</label>
                  </div>
                  <textarea
                    className="form-control"
                    id="description"
                    rows="5"
                    required
                  ></textarea>
                </div>
                <button className="btn btn-primary">اضافه کردن</button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
